// PhotosTab.js
// Wrapper component for the Photos tab in the DEL form Misc section
// Uses the reusable PhotosComponent

import { PhotosComponent } from "../../../common/PhotosComponent";
import { useUserState } from "../../../../context/user";
import styles from "./PhotosTab.module.css";

/**
 * PhotosTab component - wrapper for PhotosComponent in DEL form context
 * @param {object} callbacks - Contains delData, delMode, emitPatch, photosUI, connectionStatus
 * @param {object} photosActions - Actions from makePhotosActions
 * @param {function} showLoading - Show loading modal function
 * @param {function} hideLoading - Hide loading modal function
 * @param {function} showNotification - Show notification function
 */
export const PhotosTab = ({
  callbacks,
  photosActions,
  showLoading,
  hideLoading,
  showNotification,
}) => {
  const currentUser = useUserState().currentUser;

  const isViewMode = callbacks.delMode === "view";

  // Can download if: user created the DEL OR user has access_level >= 2
  const canDownload =
    callbacks.delData?.user_id === currentUser?.employee_id ||
    currentUser?.access_level >= 2;

  return (
    <div className={styles.photosTabContainer}>
      <PhotosComponent
        photos={callbacks.delData?.photos || []}
        photosUI={callbacks.photosUI}
        photosActions={photosActions}
        emitPatch={callbacks.emitPatch}
        isViewMode={isViewMode}
        connectionStatus={callbacks.connectionStatus}
        canDownload={canDownload}
        formId={callbacks.delData?.id}
        formType="del"
        showLoading={showLoading}
        hideLoading={hideLoading}
        showNotification={showNotification}
      />
    </div>
  );
};

export default PhotosTab;
